window.am = window.am || {};

window.am.faqrating = new function () {
    var that = this;
    var apiPath = '/api/sitecore/FaqRatingCounter/CountQuestion';

    that.init = function () {
        var ratingsButtons = document.querySelectorAll('.faq-rating a');

        ratingsButtons.forEach(function(button) {
            button.addEventListener('click', that.onRatingClick);
        });
    };

    that.onRatingClick = function () {
        var currentElement = this;
        var questionId = this.dataset.questionId;

        var postData = {
            'questionId': questionId,
            'language': this.dataset.language,
        };

        window.am.ajax.sendRequest(
            apiPath,
            'POST',
            function(response) {
                if (response == null) {
                    console.error('Cannot get valid response for faq rating counter request', response);
                } else if (response.Success === null || response.Success === false) {
                    console.error('Faq rating counter request was not successfull', response);
                } else {
                    that.countRatingTextUp(currentElement);
                    that.changeSrText(currentElement);
                    that.replaceIconFontWithSvg(currentElement);
                    that.replaceLinkWithContainer(currentElement);
                }
            },
            null,
            JSON.stringify(postData),
            false,
            false);
    };

    that.countRatingTextUp = function(rating) {
        var counterTextElement = rating.querySelector('.faq-rating__counter-inner');
        var counterValue = this.getCurrentCounterValue(rating);
        counterValue++;
        counterTextElement.innerText = counterValue;
    };

    that.getCurrentCounterValue = function(rating) {
        return rating.querySelector('.faq-rating__counter-inner').innerText;
    };

    that.changeSrText = function (element) {
        var counterValue = that.getCurrentCounterValue(element);
        var srTextElement = element.querySelector('.faq-rating__counter .sr-only');
        srTextElement.innerText = counterValue + ' ' + element.dataset.dictionaryPositiveRatingSr;
    };

    that.replaceIconFontWithSvg = function(element) {
        var icon = element.querySelector('.faq-rating__icon-star');
        icon.classList.remove('icon');
        icon.classList.remove('icons-stern-bold');
        icon.classList.add('faq-rating__icon-star--svg');
    };

    that.replaceLinkWithContainer = function(element) {
        var divContainer = document.createElement('div');
        divContainer.innerHTML = element.innerHTML;
        element.parentNode.replaceChild(divContainer, element);
    };
};

window.am.faqrating.init();